import { render, staticRenderFns } from "./BranchStatusCount.vue?vue&type=template&id=c37d19ba&"
import script from "./BranchStatusCount.vue?vue&type=script&lang=js&"
export * from "./BranchStatusCount.vue?vue&type=script&lang=js&"
import style0 from "./BranchStatusCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports